<template lang="pug">
.not-found
  .section
    .container.has-text-centered
      h1 404
      .error-message {{gettext('PAGE NOT FOUND')}}!
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from './../../services/TranslateHandler'
import mixin from '@/mixins'

export default {
  name: 'NotFound',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Page Not Found!'),
        titleTemplate: null,
        link: [
          { rel: 'canonical', href: document.location.href }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/not-found/index.vue